// extracted by mini-css-extract-plugin
module.exports = {"box":"UpgradeBanner_box__Fsgdj","container":"UpgradeBanner_container__OAgSw","close":"UpgradeBanner_close__W_O21"};